import { Button } from "antd";
import { Download, Pause, Play } from "lucide-react";
import { useMemo, useState } from "react";

export default function AudioPlayer() {
    const [playing, setPlaying] = useState(false);

    const waves = useMemo(
        () =>
            Array.from({ length: 55 }, () => 6 + Math.random() * 16),
        []
    );

    return (
        <div className="rounded-lg border border-slate-200 dark:border-neutral-700 bg-white dark:bg-[#262626] px-3 py-2">

            <div className="flex items-center gap-3 min-w-0">

                <Button
                    type="primary"
                    shape="circle"
                    size="small"
                    className="!w-9 !h-9 flex items-center justify-center"
                    onClick={() => setPlaying(!playing)}
                    icon={
                        playing ? (
                            <Pause size={15} />
                        ) : (
                            <Play size={15} className="ml-[2px]" />
                        )
                    }
                />

                <div className="flex-1 min-w-0">

                    <div className="flex items-end gap-[2px] h-6">

                        {waves.map((h, i) => (
                            <span
                                key={i}
                                className={`w-[2px] rounded-full ${i < 16
                                    ? "bg-blue-500"
                                    : "bg-slate-300 dark:bg-neutral-600"
                                    }`}
                                style={{ height: h }}
                            />
                        ))}

                    </div>

                    <div className="mt-1 h-[3px] rounded-full bg-slate-200 overflow-hidden">

                        <div className="w-[35%] h-full bg-blue-500 rounded-full" />

                    </div>

                    <div className="flex justify-between mt-1 text-[11px] text-slate-400">

                        <span>00:35</span>

                        <span>02:18</span>

                    </div>

                </div>

                <Button
                    type="text"
                    size="small"
                    className="!w-8 !h-8"
                    icon={<Download size={16} />}
                />

            </div>

        </div>
    );
}